export enum NoteEntity {
SpendingRequestDetail,
InvoiceDetail,
}
